import "slick-carousel";
import $ from "jquery";
import { Application } from "@hotwired/stimulus";
import Dropdown from "./Fusion/Presentation/Components/Dropdown/Dropdown";
import BewerberDreiOverview from "./Fusion/Presentation/Composite/BewerberDrei/BewerberDreiOverview";

window.Stimulus = Application.start()
Stimulus.register("Dropdown", Dropdown);
Stimulus.register("BewerberDreiOverview", BewerberDreiOverview);

// fix for third party js files outside of webpack
//global.$ = global.jQuery = $;

$(document).ready(function () {
    const inBackend = $('body').hasClass('neos-backend');

    // backend workarounds
    $('.neos-backend').on('click', 'a.button', function (event) {
        event.preventDefault();
    });

    $('.neos-backend').on('click', 'a.link', function (event) {
        event.preventDefault();
    });

    $('.neos-backend').on('click', '.footer a', function (event) {
        event.preventDefault();
    });

    // mobile menu
    $('*[data-action="toggle-menu"]').on('click', function () {
        $('body').removeClass('search-bar--visible');
        $('body').toggleClass('mobile-menu--visible');
    });

    // toggle search
    $('*[data-action="toggle-search').on('click', function () {
        $('body').removeClass('mobile-menu--visible');
        $('body').toggleClass('search-bar--visible');
    });

    // navigation-fixed
    let scrollTop = $(document).scrollTop();
    const headerHeight = $("header.main-header").outerHeight();

    if (scrollTop > headerHeight) {
        $("body").addClass("navigation--is-fixed");
    }

    $(window).scroll(function () {
        scrollTop = $(document).scrollTop();
        if (scrollTop > headerHeight) {
            $("body").addClass("navigation--is-fixed");
        } else {
            $("body").removeClass("navigation--is-fixed");
        }
    });

    // slides
    const autoplay = !inBackend;
    const autoplaySpeed = $('.slider__slides').data('autoplay-speed');
    $('.slider__slides .neos-contentcollection').slick({
        infinite: true,
        pauseOnHover: true,
        dots: true,
        dotsClass: 'slider__dots',
        autoplaySpeed: autoplaySpeed,
        autoplay: autoplay,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1
    });

    // job offer slides
    $('.job-offer__benefit-icons').slick({
        infinite: true,
        pauseOnHover: true,
        dots: true,
        dotsClass: 'slider__dots',
        autoplaySpeed: 3000,
        autoplay: true,
        arrows: false,
        slidesToShow: 3,
        slidesToScroll: 3,
        responsive: [
            {
                breakpoint: 9999,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                }
            },
            {
                breakpoint: 996,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                }
            },
        ]
    });

    // contact form
    $('.contact-form #form-department').on('change', function() {
        loadRegions($(this).closest('form'));
    });

    if ($('.contact-form #form-location').length > 0) {
        loadLocations($('.contact-form #form-location').closest('form'));
    }
    $('.contact-form #form-region').on('change', function() {
        loadLocations($(this).closest('form'));
    });

    // init map for locations page
    // clear lat/lng if address has changed
    $('#branch-form #street, #branch-form #postcode, #branch-form #city').on('change', function() {
        $('#branch-form').find('#lat').val("");
        $('#branch-form').find('#lng').val("");
    });
    // if branch form is submitted -> update lat/lng
    $('#branch-form').on('submit', function (event) {
        event.preventDefault();
        const promise = getLatLngForBranch();
        if (promise === false) {
            $(this).off('submit').submit();
        }
    });

    if ($('.locations').length > 0) {
        buildAccordionData($('.locations'))
    }

    bindAccordionActions();
});

function buildAccordionData($container) {
    let data = [];

    $container.find('.accordion-content').each(function() {
        const title = $(this).data('title');
        const subtitle = $(this).data('subtitle');
        if(!data[title]) {
            data[title] = {
                key: title,
                id: camelCase(title),
                values: []
            };

            if (subtitle) {
                data[title]['children'] =[];
            }
        }

        if(subtitle && !data[title]['children'][subtitle]) {
            data[title]['children'][subtitle] = {
                key: subtitle,
                id: camelCase(subtitle),
                values: []
            };
        }

        if (subtitle) {
            data[title]['children'][subtitle]['values'].push($(this));
        } else {
            data[title]['values'].push($(this));
        }
    });

    buildAccordion(data, $container);
}

function camelCase(str) {
    return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function(word, index)
    {
        return word.toLowerCase();
    }).replace(/\s+/g, '');
}

function sortAccordionKeys(data) {
    return Object.keys(data).sort(function(a, b) {
        const nameA = a.toLowerCase();
        const nameB = b.toLowerCase();
        if (nameA < nameB) {
            return -1;
        }
        if (nameA > nameB) {
            return 1;
        }

        return 0;
    });
}

function buildAccordion(data, $container, isChildren = false) {
    const $prototype = $('#accordion__tab-prototype');

    sortAccordionKeys(data).forEach((key) => {
        const accordionEntry = data[key];
        const $accordion = $prototype.clone().appendTo($container);
        $accordion.removeAttr('id');
        $accordion.find('label').text(accordionEntry['key']);
        if (isChildren) {
            $accordion.addClass('accordion__tab--is-children')
        }
        $accordion.show();
        if (accordionEntry['children']) {
            buildAccordion(accordionEntry['children'], $accordion.find('.accordion__tab-content-inner'), true)
        } else {
            accordionEntry['values'].forEach(function(entry) {
                $accordion.find('.accordion__tab-content-inner').append(entry);
            });
        }
    })
}

function bindAccordionActions() {
    $('.accordion__tab').each(function(index, item) {
        $(item).find('label').first().on('click', function() {
            if ($(this).closest('.accordion__tab').hasClass('accordion__tab--active')) {
                $(this).closest('.accordion__tab').removeClass('accordion__tab--active');
                $(this).closest('.accordion__tab').find('.accordion__tab-content').first().slideUp();
            } else {
                if ($(this).closest('.accordion__tab').hasClass('accordion__tab--is-children')) {
                } else {
                    $('.accordion__tab--active').find('.accordion__tab-content').first().slideUp();
                    $('.accordion__tab--active').removeClass('accordion__tab--active');
                }

                $(this).closest('.accordion__tab').addClass('accordion__tab--active');
                $(this).closest('.accordion__tab').find('.accordion__tab-content').first().slideDown();
            }
        });
    })
}

// for contact form
function loadRegions($form) {
    const regionsAjaxUri = $('.contact-form').data('regions-uri');
    const language = $('.contact-form').data('language');
    const departmentId = $('.contact-form #form-department').val();

    $('.contact-form #form-region').empty();
    $('.contact-form #form-location').empty();

    const data = {
        'departmentId': departmentId,
        'language': language
    };

    // load available regions for selected department
    $('.contact-form').addClass('contact-form--is-loading');
    $.ajax({
        data: data,
        type: 'POST',
        url: regionsAjaxUri,
        dataType: "json",
        complete: function() {
            $('.contact-form').removeClass('contact-form--is-loading');
        },
        success: function(data) {
            $.each(data, function(key,value) {
                $('.contact-form #form-region').append($("<option></option>").attr("value", key).text(value));
            });

            loadLocations($form);
        },
    });
}
// for contact form
function loadLocations($form) {
    if($form.find('#form-location').length === 0) {
        return
    }

    const locationsAjaxUri = $('.contact-form').data('locations-uri');
    const language = $('.contact-form').data('language');
    const regionId = $('.contact-form #form-region').val();

    $('.contact-form #form-location').empty();

    const data = {
        'regionId': regionId,
        'language': language
    };

    // load available regions for selected department
    $('.contact-form').addClass('contact-form--is-loading');
    $.ajax({
        data: data,
        type: 'POST',
        url: locationsAjaxUri,
        dataType: "json",
        complete: function() {
            $('.contact-form').removeClass('contact-form--is-loading');
        },
        success: function(data) {
            $.each(data, function(key,value) {
                $('.contact-form #form-location').append($("<option></option>").attr("value", key).text(value));
            });
        },
    });
}

let geocoder;
let map;
// init the locations map and zoom on the location + add markers for each branch
function initMap() {
    if ($('#locations-map').length === 0) {
        return
    }
    geocoder = new google.maps.Geocoder();
    map = new google.maps.Map(document.getElementById('locations-map'), {
        zoom: 13,
    });

    const bounds = new google.maps.LatLngBounds();
    const iconPath = $('#locations-map').data('map-icon-url');
    const infoWindow = new google.maps.InfoWindow();

    // add markers for each branch
    let lat = null;
    let lng = null;
    $('.branch').each(function() {
        lat = $(this).data('lat');
        lng = $(this).data('lng');
        const title = $(this).data('title');

        if (!!lat && !!lng) {
            const marker = new google.maps.Marker({
                position: {lat: lat, lng: lng},
                map: map,
                icon: iconPath,
                title: title,
                info: $(this).html()
            });
            marker.addListener('click', function() {
                infoWindow.setContent(marker.get('info'));
                infoWindow.open(map, marker);
            });
            bounds.extend({lat: lat, lng: lng})
        }
    });
    if($('.branch').length > 1) {
        map.fitBounds(bounds);
        // restore the zoom level after the map is done scaling
        const listener = google.maps.event.addListener(map, "bounds_changed", function () {
            map.setZoom(map.getZoom() - 1);
            google.maps.event.removeListener(listener);
        });
    } else {
        map.setCenter({lat: lat, lng: lng})
    }
}

// set to global scope -> used as callback for loaded maps api
window.initMap = initMap;

// update the lat/lng for a given address when updating the branches in the backend
function getLatLngForBranch() {
    const $branchForm = $('#branch-form');
    if ($branchForm.length === 0) {
        return false
    }
    if ($branchForm.find('#lat').val().length !== 0) {
        return false
    }

    geocoder = new google.maps.Geocoder();
    const address = $branchForm.find('#street').val() + ', ' + $branchForm.find('#postcode').val() + ' ' + $branchForm.find('#city').val()
    codeAddress(address, function(latlng) {
        if (latlng === null) {
            $branchForm.off('submit').submit();
            return
        }
        $branchForm.find('#lat').val(latlng.lat);
        $branchForm.find('#lng').val(latlng.lng);

        // submit form
        $branchForm.off('submit').submit();
    });
}

function codeAddress(address, callback) {
    if(address.length === 0 ) {
        return false
    }
    geocoder.geocode({ 'address': address }, function (results, status) {
        if (results.length === 0) {
            return false
        }
        const latLng = {lat: results[0].geometry.location.lat (), lng: results[0].geometry.location.lng ()};
        if (status === 'OK') {
            if (callback) {
                callback(latLng);
            } else {
                new google.maps.Marker({
                    position: latLng,
                    map: map,
                });
            }
        } else {
            alert('Geocode was not successful for the following reason: ' + status);
            if (callback) {
                callback(null);
            }
        }
    });
}
